// src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const VALID_USER = 'admin@segos.com';
const VALID_PASS = 'admin123456';

const Login = () => {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const u = (usuario || '').trim().toLowerCase();
    const p = (clave || '').trim();

    if (u === VALID_USER && p === VALID_PASS) {
      localStorage.setItem('logeado', 'true');
      // dispara un evento para notificar a la app que cambió el auth
      window.dispatchEvent(new Event('auth:changed'));
      navigate('/rentas');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Credenciales incorrectas',
        text: 'El usuario o la contraseña no son correctos.',
      });
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="col-12 col-md-6 col-lg-4">
        <div className="card shadow">
          <div className="card-body p-4">
            <h3 className="card-title text-center mb-4">Iniciar Sesión</h3>
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label">Usuario</label>
                <input
                  type="email"
                  className="form-control"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  placeholder="admin@segos.com"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="form-label">Contraseña</label>
                <input
                  type="password"
                  className="form-control"
                  value={clave}
                  onChange={(e) => setClave(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-dark w-100">
                Entrar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
